var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M18.071 3.833H4.655A1.917 1.917 0 0 0 2.738 5.75v13.417c0 1.058.858 1.916 1.917 1.916H18.07a1.917 1.917 0 0 0 1.917-1.916V5.75a1.917 1.917 0 0 0-1.917-1.917Zm-2.875-1.916V5.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M7.53 1.917V5.75M2.738 9.583h17.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatum);
export default __webpack_public_path__ + "static/media/datum.4a55f132.svg";
export { ForwardRef as ReactComponent };